/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;width:100%;padding:.375rem .75rem;font-size:14px;line-height:1.5;color:#55595c;background-color:#fff;background-image:none;border:1px solid rgba(120,130,140,.2);min-height:2.375rem;border-radius:3px}"];
export { styles as styles };
